// extracted by mini-css-extract-plugin
module.exports = {"properties":"PropertiesSection_properties__FHNXV"};